export default __webpack_public_path__ + "static/media/google-cloud-logo.c2e5931d.svg";